import React, { useEffect, useState, useRef } from "react";
import { getAnnouncement, markAnnouncementSeen } from "@/lib/api";
import { Megaphone, X } from "lucide-react";

export default function AnnouncementPopup() {
  const [ann, setAnn] = useState(null);
  const shownIds = useRef(new Set());

  const check = async () => {
    try {
      const a = await getAnnouncement();
      if (a && !shownIds.current.has(a.id)) {
        shownIds.current.add(a.id);
        setAnn(a);
      }
    } catch { /* noop */ }
  };

  useEffect(() => {
    check();
    const t = setInterval(check, 15000);
    return () => clearInterval(t);
  }, []);

  const close = async () => {
    try { await markAnnouncementSeen(); } catch { /* noop */ }
    setAnn(null);
  };

  const go = async () => {
    const url = ann?.url;
    await close();
    if (url) window.location.assign(url);
  };

  if (!ann) return null;
  return (
    <div className="ann-overlay" data-testid="announcement-popup" onClick={close}>
      <div className="ann-card" onClick={(e) => e.stopPropagation()}>
        <button className="ann-x" onClick={close} data-testid="announcement-close" aria-label="Cerrar"><X size={18} /></button>
        <div className="ann-icon"><Megaphone size={30} /></div>
        <span className="ann-tag">Aviso del equipo Liberti</span>
        <h2 className="ann-title" data-testid="announcement-title">{ann.titulo}</h2>
        {ann.cuerpo && <p className="ann-body">{ann.cuerpo}</p>}
        <div className="ann-actions">
          {ann.url && <button className="btn btn-gold" onClick={go} data-testid="announcement-go">Ver contenido</button>}
          <button className="abtn" onClick={close} data-testid="announcement-ok">Entendido</button>
        </div>
      </div>
    </div>
  );
}
